<div #container>
    <app-portada-fichas [continua]="true" *ngIf="datos" [viewVenue]="true" [viewArea]="true" [paddingRight]="'13vw'"
        [datos]="datos" [carrer]="carrer" [venue]="venue" [region]="datos.region"
        [svgContent]="svgContent"></app-portada-fichas>


    <section id="section-primary" *ngIf="datos">
        <div class="contenedores-seccion-aranceles no-margin">
            <app-aranceles-cursos [datos]="datos" [cuotas]="cuotas"></app-aranceles-cursos>
        </div>
    </section>
    <section *ngIf="imagesSlider.length > 0">
        <app-slider [images]="imagesSlider"></app-slider>
    </section>
    <section *ngIf="datos">
        <div class="contenedores-seccion">
            <app-plan-de-estudio-educacion-continua [planData]="datos.studyPlanItems"
                [methodPay]="(!datos.curso_gratuito) ? datos.general_data_obj?.metodos_pago : null" [image]="datos.image" [workload]="datos.workload"
                [titlesPlanData]="datos.title" [html]="datos.graphic" [backgroudColor]="datos.color"
                [docentes]="datos.teaching"></app-plan-de-estudio-educacion-continua>
        </div>
    </section>
    <section *ngIf="datos && datos.area_tematica?.length > 0">
        <div class="contenedores-seccion">
            <div class="titulo-propuesta">
                <h2 class="quicksand-bold title ">PROPUESTAS ACADÉMICAS RELACIONADAS</h2>
            </div>
            <div class="articulacion-botones ">
                <div *ngFor="let area of datos.area_tematica">
                    <ng-container *ngFor="let button of area.subcategorias;">
                        <button class="btn-articulacion quicksand-medium"
                            [routerLink]="['/' + language + '/' + area.url]" [queryParams]="{ categoria: button.id }" >
                            {{button.name}}
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>
    </section>
    <section
        *ngIf="datos && datos.general_data_obj && datos.general_data_obj?.faqs && datos.general_data_obj?.faqs?.length >0">
        <div class="contenedores-seccion">
            <div class="titulo-propuesta">
                <h2 class="quicksand-bold title ">PREGUNTAS FRECUENTES</h2>

            </div>
            <div class="container-faqs row">
                <div class="fabs-divider">
                    <div *ngFor="let faq of datos.general_data_obj?.faqs | slice:0:getHalfLength(); let i = index">
                        <div *ngIf="faq.estado">
                            <div class="div-preguntas" (click)="open(i)">
                                <h2 class="quicksand-medium">{{faq.ask}}</h2>

                                <img onerror="this.src='./assets/img/default.png'"
                                    [src]="visibleFaqs[i] ? './assets/img/flecha-arriba-continua.png' : './assets/img/flecha-abajo-continua.png'"
                                    class='icon pointer float-right inline' id="arrow" alt="">

                            </div>

                            <div *ngIf="visibleFaqs[i]">
                                <div class="container-respuesta">
                                    <span class="respuesta quicksand-medium">{{faq.answer}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="fabs-divider">
                    <div
                        *ngFor="let faq of datos.general_data_obj?.faqs | slice:getHalfLength():datos.general_data_obj?.faqs.length; let j = index">
                        <div *ngIf="faq.estado">
                            <div class="div-preguntas" (click)="open(j + getHalfLength())">
                                <h2 class="quicksand-medium">{{faq.ask}}</h2>

                                <img onerror="this.src='./assets/img/default.png'"
                                    [src]="visibleFaqs[j + getHalfLength()] ? './assets/img/flecha-arriba-continua.png' : './assets/img/flecha-abajo-continua.png'"
                                    class='icon pointer float-right inline' id="arrow" alt="">

                            </div>

                            <div *ngIf="visibleFaqs[j + getHalfLength()]">
                                <div class="container-respuesta">
                                    <span class="respuesta quicksand-medium">{{faq.answer}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="!isDesktop" class="linea"></div>
        </div>
    </section>
    <section *ngIf="datos">
        <div class="contenedores-seccion">
            <div class="div-condiciones ">
                <div class="divbtn-condiciones1">
                    <a class="btn-condiciones nunito-medium zoomIn"
                        href="https://uca.edu.ar/es/posgrado/terminos-y-condiciones" target="_blank">
                        TÉRMINOS Y CONDICIONES
                    </a>
                </div>

                <div class="divbtn-condiciones2">
                    <a class="btn-condiciones nunito-medium  zoomIn" [href]="datos.regret" target="_blank">
                        BOTÓN DE ARREPENTIMIENTO
                    </a>
                </div>




            </div>
        </div>

    </section>
</div>